<div class="container">
	<div class="inner-container container">
		<div class="signin-container">
			<h2>Log in</h2>
			<form action="#" (submit)="signIn()">
				<text-field [width]="360" height="8" (inputChange)="setInput($event, 'email')" [label]="'Email'" [type]="'email'"></text-field>
				<text-field [width]="360" height="8" (inputChange)="setInput($event, 'password')" [label]="'Password'" [type]="'password'"></text-field>
				<p class="warning-text">{{error}}</p>
				<button type="submit" class="submit-btn" #submitButton>Log in</button>
			</form>
			<a href="#" routerLink="/accountrecovery" [queryParams]="{mode: 'forgotPassword'}" class="login-link">Forgot password?</a>
			<p class="login-link">Don't have an account? <a href="#" routerLink="/signup" class="login-link">Sign up</a></p>
		</div>
		<div class="divider spanning-content">
			<div class="spacer"></div>
			<p>OR</p>
			<div class="spacer"></div>
		</div>
		<div class="signin-container">
			<button (click)="signIn('Google')" type="submit" class="submit-btn social-signin">
				Log in with Google
				<img src="/assets/icons/google_logo.svg" alt="Google logo">
			</button>
		</div>
	</div>
	
</div>
